export const encodeURL = (url: string): string =>
    encodeURI(url)
        .replace(/'/g, '%27')
        .replace(/\(/g, '%28')
        .replace(/\)/g, '%29');
